module.exports = __webpack_public_path__ + "img/5.0cd68b0.svg";